import { render, staticRenderFns } from "./OptionsAPR.vue?vue&type=template&id=c45d5610"
import script from "./OptionsAPR.vue?vue&type=script&lang=js"
export * from "./OptionsAPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports